export default "__VITE_ASSET__EvtgaiJj__"